import React from "react";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import Button from "@mui/material/Button";
import {setLookOpened} from "../../../actions/lookFunctions";

export const SqftFeaturesPopupSaveImageButton = (props) => {
  const {lookOpened, setLookOpened} = props;

  return (
    <Button className={"ui-button2 ui-button2--primary-border"}
            onClick={() => setLookOpened(!lookOpened)}>
      <FormattedMessage id="CHANGE COLOR"/>
    </Button>
  )
};

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  const {lookOpened} = store.lookState;
  return {
    isMobile,
    lookOpened,
    cabinetsGlb: store.sqftState.cabinetsGlb,
    activeTheme: store.serverState.activeTheme,
  };
};
const mapDispatchToProps = {
  setLookOpened,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftFeaturesPopupSaveImageButton)
)
